import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import TedApp from "./TedApp";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TedApp />
  </StrictMode>,
);
